import * as types from './mutation-types'

export default {
  [types.SET_UNITY] (state, payload) {
    state.unity = payload
  },
  [types.SET_UNITIES] (state, payload) {
    state.unities = payload
  },
  [types.SET_PAGINATION] (state, payload) {
    state.pagination = payload
  }
}
